<template>
  <div class="section" id="get-delete">
    <h2>GET delete</h2>
    <div class="contents local topic" id="contents">
      <ul class="simple">
        <li>
          <a class="reference internal" href="#delete-resource-url" id="id1">DELETE resource URL</a>
        </li>
        <li><a class="reference internal" href="#performance" id="id2">Performance</a></li>
        <li><a class="reference internal" href="#parameters" id="id3">Parameters</a></li>
        <li><a class="reference internal" href="#request-example" id="id4">Request example</a></li>
        <li>
          <a class="reference internal" href="#response-examples" id="id5">Response examples</a>
          <ul>
            <li><a class="reference internal" href="#json-success" id="id6">Success</a></li>
            <li><a class="reference internal" href="#json-failure" id="id7">Failure</a></li>
          </ul>
        </li>
      </ul>
    </div>
    <p>Given an image file path, delete the image from the collection.</p>
    <div class="section" id="delete-resource-url">
      <h3>DELETE resource URL</h3>
      <div class="highlight-python">
        <div class="highlight">
          <pre><span></span>https://matchengine.tineye.com/&lt;company&gt;/rest/delete/</pre>
        </div>
      </div>
    </div>
    <delete-method-widget
      :username="username"
      :password="password"
      :user-url-base="userUrlBase"
      :proxy-url-base="proxyUrlBase"
      :language="language"
      @language-change="language = $event"
      >Interactive example</delete-method-widget
    >

    <div class="section" id="performance">
      <h3>Performance</h3>
      <p>
        The MatchEngine API can perform one add or delete operation at a time. Any extra requests
        submitted will be queued up for processing as slots become available.
      </p>
    </div>
    <div class="section" id="parameters">
      <h3>Parameters</h3>
      <p>
        In addition to the
        <router-link class="reference internal" to="../api_reference#common-parameters"
          ><span>common parameters</span></router-link
        >
        there are:
      </p>
      <table border="1" class="docutils">
        <colgroup>
          <col width="32%" />
          <col width="68%" />
        </colgroup>
        <thead valign="bottom">
          <tr class="row-odd">
            <th class="head">Key</th>
            <th class="head">Description</th>
          </tr>
        </thead>
        <tbody valign="top">
          <tr class="row-even">
            <td><strong>filepath</strong></td>
            <td>
              A file path (as returned by the <cite>list</cite> operation) which we want to delete.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="section" id="request-example">
      <h3>Request example</h3>
      <div class="highlight-bash">
        <div class="highlight">
          <pre><span></span>curl -X DELETE <span class="s2">"https://matchengine.tineye.com/&lt;company&gt;/rest/delete/?filepath=1.jpg"</span></pre>
        </div>
      </div>
    </div>
    <div class="section" id="response-examples">
      <h3>Response examples</h3>
      <div class="section" id="json-success">
        <h4>Success</h4>
        <div class="highlight-json response">
          <div class="highlight">
            <pre><span></span><span class="p">{</span>
      <span class="nt">"status"</span><span class="p">:</span> <span class="s2">"ok"</span><span class="p">,</span>
      <span class="nt">"method"</span><span class="p">:</span> <span class="s2">"delete"</span><span class="p">,</span>
      <span class="nt">"error"</span><span class="p">:</span> <span class="p">[],</span>
      <span class="nt">"result"</span><span class="p">:</span> <span class="p">[]</span>
    <span class="p">}</span></pre>
          </div>
        </div>
      </div>
      <div class="section" id="json-failure">
        <h4>Failure</h4>
        <div class="highlight-json response">
          <div class="highlight">
            <pre><span></span><span class="p">{</span>
      <span class="nt">"status"</span><span class="p">:</span> <span class="s2">"warn"</span><span class="p">,</span>
      <span class="nt">"method"</span><span class="p">:</span> <span class="s2">"delete"</span><span class="p">,</span>
      <span class="nt">"error"</span><span class="p">:</span> <span class="p">[</span>
        <span class="s2">"1.jpg: Failed to remove from index."</span>
      <span class="p">],</span>
      <span class="nt">"result"</span><span class="p">:</span> <span class="p">[]</span>
    <span class="p">}</span></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeleteMethodWidget from "@/components/DeleteMethodWidget.vue";

export default {
  name: "delete_method_reference",
  data: function () {
    return {
      language: "python",
      username: "matchengine_user",
      password: "matchengine_password",
      userUrlBase: "https://matchengine.tineye.com/sandbox",
      proxyUrlBase: "/matchengine_sandbox",
    };
  },
  components: {
    DeleteMethodWidget,
  },
};
</script>
